const requireModule = require.context('.', false, /\.js$/)

const lang = {}

requireModule.keys().forEach(fileName => {
  const module = fileName.replace(/(\.\/|\.js)/g, '')
  if (module === 'ja') {
    return
  }

  lang[module] = { ...requireModule(fileName).default }
})

export default lang
